import { message } from "antd";
import i18n from "../localization/i18n";
import {
  setAnsweredQuestions,
  setInnerStepper,
  setStepperStatus,
  setTotalQuestions,
} from "../redux/slices/common_slice";
import { setType } from "../redux/slices/dashboard_slice";

export const convertCurrency = (value, exchangeRates, currency) => {
  if (!exchangeRates || !value) return;

  const rate = exchangeRates[currency];
  if (rate) {
    const converted = parseFloat(value) * rate;
    return Math.round(converted); // Round to 2 decimal places
  }
};

export const reorderCurrencies = (exchangeRates) => {
  const prioritizedCurrencies = ["CAD", "USD", "EUR", "INR"];

  const prioritized = prioritizedCurrencies.reduce((acc, code) => {
    if (exchangeRates[code]) acc[code] = exchangeRates[code];
    return acc;
  }, {});

  const remainingCurrencies = Object.keys(exchangeRates)
    .filter((code) => !prioritizedCurrencies.includes(code))
    .sort()
    .reduce((acc, code) => {
      acc[code] = exchangeRates[code];
      return acc;
    }, {});

  return { ...prioritized, ...remainingCurrencies };
};

export const getCurrentMonthYear = () => {
  const currDate = new Date();
  const month = String(currDate.getMonth() + 1).padStart(2, "0");
  const year = currDate.getFullYear();
  return `${month}-${year}`;
};

export const getOptionsArray = (exchangeRates) => {
  const optionsArray = Object.keys(exchangeRates)?.map((rate) => {
    return { value: rate, label: rate };
  });
  return optionsArray;
};

export const getRelevantData = (data, item_name) => {
  const filteredArr = data.filter((i) => i.item_name.includes(item_name));
  return filteredArr;
};

export const getCategoryData = (data, item_name) => {
  const foundItem = data.find((i) => i.category === item_name);
  return foundItem;
};

export const clearLocalStoragenNavigate = (
  dispatch,
  navigate,
  setUserData,
  onClose,
  path
) => {
  localStorage.clear();
  dispatch(setUserData(null));
  dispatch(setStepperStatus(null));
  dispatch(setInnerStepper(0));
  dispatch(setAnsweredQuestions(0));
  dispatch(setTotalQuestions(0));
  dispatch(setType("all"));
  onClose();
  navigate(path);
};
export const getErrorDataClassName = (fieldName, formik) => {
  if (formik.errors?.[fieldName]) {
    return "error-fill";
  } else if (formik.values?.[fieldName]) {
    return "data-fill";
  } else {
    return "";
  }
};

export const isFalsyExceptZero = (value) => {
  return !value && value !== 0;
};

export const handleKeyDown = (event) => {
  const allowedKeys = [
    "Backspace",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Tab",
    "Enter",
  ];

  // Allow allowed keys
  if (allowedKeys.includes(event.key)) {
    return; // Allow if the key is allowed
  }

  // Check for number input
  if (/^[0-9]$/.test(event.key)) {
    // Get the current value and simulate the new value
    const currentValue = event.target.value.replace(/,/g, "");
    const newValue = currentValue + event.key;

    // If the new value exceeds 500,000
    if (Number(newValue) > 500000) {
      message.error(i18n.t("errors.maxAmt"));
      event.preventDefault();
    }
    return; // Allow if the key is a digit and does not exceed limit
  }

  // Prevent default for disallowed keys
  event.preventDefault();
};

export const formatNumber = (value) => {
  if (isFalsyExceptZero(value)) return "";
  const formattedVal = Number(String(value)?.replace(/,/g, ""));
  // Remove any non-numeric characters except dots and commas
  if (isNaN(formattedVal)) {
    return "";
  }
  return Number(String(value)?.replace(/,/g, "")).toLocaleString("en-US");
};

export const isPWA = () => {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  return isStandalone;
};

// API errors usually carry { message: { en, fr, ... } }, but validation and
// infrastructure errors can return a plain string — never show "undefined".
export const getApiErrorMessage = (err, fallback) => {
  const msg = err?.message;
  if (typeof msg === "string") return msg;
  return (
    msg?.[i18n.language] ||
    msg?.en ||
    fallback ||
    i18n.t("errors.socialLoginFailed")
  );
};
